import { Box } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { List } from "@material-ui/core";
import React, { useState } from "react";
import Reports from "./Report";
import './style.css';
import UserReport from "./UserReports";
import ReportList from "./ReportList";
import CouponReports from "./CouponsReport";
import CharitiesReport from './CharitiesReport';
import VoucherReport from './VoucherReport';
import TransactionReport from './TransactionReport';
import DailyReport from './DailyReport';

enum ReportsTabsIds {
  Daily = "dailyReports",
  Weekly = "weeklyReports",
  Users = "usersReports",
  Coupons = "couponsReport",
  Charities = "charitiesReport",
  Voucher = "voucherReport",
  Transactions = "transactionsReport",
  ReportList = "reportList",
}
const Tabs = [
  {
    title: 'Daily report',
    id: ReportsTabsIds.Daily,
  },
  {
    title: 'Weekly reports',
    id: ReportsTabsIds.Weekly,
  },
  {
    title: 'Users report',
    id: ReportsTabsIds.Users,
  },
  {
    title: 'Coupons report',
    id: ReportsTabsIds.Coupons,
  },
  {
    title: 'Charities report',
    id: ReportsTabsIds.Charities,
  },
  {
    title: 'Voucher report',
    id: ReportsTabsIds.Voucher,
  },
  {
    title: 'Transactions report',
    id: ReportsTabsIds.Transactions,
  },
  {
    title: 'Report list',
    id: ReportsTabsIds.ReportList,
  },
];

export const ReportsLayout = () => {
  const [currentTabId, setCurrentTabId] = useState<string>(
    ReportsTabsIds.Daily
  );

  const redirectToReportList = () => {
    setCurrentTabId(ReportsTabsIds.ReportList);
  };

  return (
    <Box className="generalTabMainWrapper reportsTabMainWrapper">
      <Box className="reportsTabsWrapper">
        <List>
          {Tabs.map((i, index) => {
            return (
              <Box
                key={index}
                onClick={() => setCurrentTabId(i.id)}
              >
                <p
                  className={`generalTabWrapper ${i.id === currentTabId ? "active" : ""
                    }`}
                >
                  <span>{i.title}</span>
                </p>
              </Box>
            );
          })}
        </List>
      </Box>
      <Box className="generalTabContentWrapper">
        {currentTabId === ReportsTabsIds.Daily ? <DailyReport /> : null}
        {currentTabId === ReportsTabsIds.Weekly ? <Reports redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.Users ? <UserReport redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.Coupons ? <CouponReports redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.Charities ? <CharitiesReport redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.Voucher ? <VoucherReport redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.Transactions ? <TransactionReport redirectToReportList={redirectToReportList} /> : null}
        {currentTabId === ReportsTabsIds.ReportList ? <ReportList /> : null}
      </Box>
    </Box>
  );
}